export const FETCH_CONTRACTOR_SHOWS_REQUEST = "FETCH_CONTRACTOR_SHOWS_REQUEST";
export const FETCH_CONTRACTOR_SHOWS_SUCCESS = "FETCH_CONTRACTOR_SHOWS_SUCCESS";
export const FETCH_CONTRACTOR_SHOWS_FAILURE = "FETCH_CONTRACTOR_SHOWS_FAILURE";
